import React from 'react';

const EmbeddedVideo = ({ youtubeUrl }) => {
  return (
    <div className="embedded-video">
      <iframe
        src={youtubeUrl}
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        style={{ width: '100%', height: '100%' }}
      ></iframe>
    </div>
  );
};

export default EmbeddedVideo;
